import { makeStyles } from "@fluentui/react-components";
import { SkanskaColorTokens } from "../../style/colors";

export const useActivtyContentClasses = makeStyles({
  activityContent: {
    // Ensure images never exceed the container's width
    "& img": {
      maxWidth: "100%",
      height: "auto",
      display: "inline-block",
      padding: "12px 0 !important", // match paragraph spacing
    },
    // Left-aligned images
    "& p[style*='text-align: left'] img, & p[style*='text-align: start'] img": {
      marginLeft: "0",
      marginRight: "auto",
    },
    // Center-aligned images
    "& p[style*='text-align: center'] img": {
      marginLeft: "auto",
      marginRight: "auto",
    },
    // Right-aligned images
    "& p[style*='text-align: right'] img, & p[style*='text-align: end'] img": {
      marginLeft: "auto",
      marginRight: "0",
    },
    // Justify behaves like left alignment for images
    "& p[style*='text-align: justify'] img": {
      marginLeft: "0",
      marginRight: "auto",
    },
    // Images with explicit aspect-ratio should not have auto height
    "& img[style*='aspect-ratio']": {
      height: "unset",
    },
    // Ensure paragraphs containing images don't allow inline content next to images
    "& p:has(img)": {
      display: "block",
      clear: "both",
    },
    //styling for paragraphs
    "& mark": {
      backgroundColor:
        SkanskaColorTokens.color_tertiary_orange_30 + "!important",
    },
    "& p ": {
      fontSize: "18px !important",
      lineHeight: "1.5 !important",
      //70ch since space is not counted as character
      maxWidth: "70ch !important",
      margin: "12px 0 !important",
    },
    "& ul, & ol": {
      fontSize: "18px !important",
      lineHeight: "1.5 !important",
      margin: "12px 0 !important",
      paddingLeft: "32px !important",
    },
    "& ul ul, & ul ol, & ol ul, & ol ol": {
      margin: "0 !important",
    },
    "& li": {
      fontSize: "18px !important",
      lineHeight: "1.5 !important",
    },
    "& li > p": {
      fontSize: "inherit !important",
      lineHeight: "inherit !important",
      margin: "0 !important",
      maxWidth: "none !important",
    },
    "& span": {
      fontSize: "18px !important",
      lineHeight: "1.5",
      //70ch since space is not counted as character
      maxWidth: "70ch !important",
    },
    "& a": {
      color: SkanskaColorTokens.color_primary_blue,
    },
    "& a:hover": {
      textDecoration: "underline !important",
    },
    // Style for inactive/archived tool links
    "& a[data-tool-link-id][style*='pointer-events: none']": {
      cursor: "default !important",
      color: "#666 !important",
    },
    "& h2,h3,h4": {
      marginBottom: 0,
    },
    // Keep the chevron aligned with the first text line when long headings wrap.
    "& h2 > button[aria-expanded]": {
      paddingLeft: "0 !important",
      paddingTop: "0 !important",
      paddingBottom: "0 !important",
      display: "flex",
      alignItems: "flex-start",
      textAlign: "left",
      width: "100%",
    },
    "& h2 > button[aria-expanded] > .fui-AccordionHeader__expandIcon": {
      display: "flex",
      alignItems: "flex-start",
      flexShrink: 0,
      marginTop: "0.6em",
    },
    "& table": {
      maxWidth: "100%",
      "& p ": {
        margin: "0 !important",
        minHeight: "27px",
      },
      "& th": {
        "& p": {
          fontWeight: "bold",
        },
      },
      "& td": {
        verticalAlign: "top",
      },
    },
    "& table[data-table-width]": {
      // Ensure tables with data-table-width attribute always use that width and min-width from the attribute
      // The width and min-width should be set via inline styles from the TableStylesExtension and useApplyTableWidths hook
      boxSizing: "border-box",
      tableLayout: "fixed", // Ensures width and min-width are respected
      "& td, & th": {
        wordWrap: "break-word",
        overflow: "hidden",
        minWidth: "0", // Allow cells to shrink but respect table min-width
      },
    },
    "& .transparent-table": {
      border: "none !important",
      background: "transparent !important",
      "& th": {
        border: "none !important",
        background: "#f2f2f2 !important",
      },
      "& td": {
        border: "none !important",
        background: "transparent !important",
      },
      "& tr:hover": {
        background: "transparent !important",
      },
    },
    "& .warning-table": {
      border: "2px solid #ff9900 !important",
      borderCollapse: "collapse",
      "& th": {
        border: "1px solid #ff9900 !important",
      },
      "& td": {
        border: "1px solid #ff9900 !important",
      },
    },
  },
});
